import { FC } from "react";
import { Modal as BoostrapModal } from "react-bootstrap";
import { SummaryModalProps } from "./types";
import style from "./style.module.scss";
import { MessageComponent } from "components/message";

export const SummaryModal: FC<SummaryModalProps> = (props) => {
  const {
    show,
    type,
    title,
    buttonText = "OK",
    successListItem,
    failureListItem,
  } = props;
  const { handleCloseModal } = props;
  return (
    <BoostrapModal show={show} onHide={handleCloseModal} centered>
      <BoostrapModal.Body>
        <div className="d-flex flex-column align-items-center gap-3 m-4">
          <i
            className={`bi ${
              type === "error"
                ? "bi-x-circle"
                : type === "info"
                ? "bi-exclamation-circle"
                : "bi-check-circle"
            } ${style.icon} ${style[type]}`}
          ></i>
          <h6 className={style.title}>{title}</h6>
          <div>
            {successListItem.map((o, i) => (
              <MessageComponent key={i} message={o} type="success" />
            ))}
            {failureListItem.map((o, i) => (
              <MessageComponent key={i} message={o} type="error" />
            ))}
          </div>
          <div>
            <button
              className="btn btn-primary submit-btn text-white w-100"
              onClick={handleCloseModal}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </BoostrapModal.Body>
    </BoostrapModal>
  );
};
